import React, { useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { MapLeaflet } from '../components/mapLeaflet';
import emailjs from '@emailjs/browser';
import classNames from "classnames";


export const ContactsPage = () => {
  const [submitting, setSubmitting] = useState(false);

  const [{
    name,
    email,
    phone,
    subject,
    message
  }, setValues] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [errors, setErrors] = useState({
    name: false,
    email: false,
    phone: false,
    subject: false,
    message: false,
  });


  const handleChange = (event) => {
    const { name: field, value } = event.target;

    setValues(current => ({ ...current, [field]: value }));
    setErrors(current => ({ ...current, [field]: false }));
  };

  const clearForm = () => {
    setValues({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });

    setErrors({
      name: false,
      email: false,
      phone: false,
      subject: false,
      message: false,
    });
  };


  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setSubmitting(true)

    setErrors({
      name: !name,
      email: !email,
      message: !message,
      phone: !phone,
      subject: !subject,
    });

    if (!name || !email || !message || !phone || !subject) {
      setSubmitting(false);
      return;
    }

    emailjs.sendForm('service_9b8hu7h', 'template_a9nz65p', formRef.current, 'FJ8XykqucxwlwNMeM')
      .then(() => {
        setSubmitting(false);
        clearForm();
      }, (error) => {
        setSubmitting(false)
        throw error;
      });
  };

  return <>
    <div className="contact__page">
      <div className="contact__block">
        <div className="contact__block__top">
          <div className="contact__block__image"></div>
          <div className="contact__block__main">
            <div className="contact__block__title">
              <h2 className="title__h2">
                <span
                  className="title__normal title__normal--purple"
                >
                  Contact
                </span>
                <br/>
                <span className="title__storng">Information</span>
              </h2>
              <p className="title__description">
                Our team is ready to accept any of your orders, develop specifications and execute them at the most convenient time for you.
              </p>
            </div>
            <div className="contact__block__contacts">
              <div className="mini__block">
                <h3>Office</h3>
                <a href="https://www.google.com/maps/place/71+Baggot+Street+Lower,+Dublin,+D02+P593,+%D0%98%D1%80%D0%BB%D0%B0%D0%BD%D0%B4%D0%B8%D1%8F/data=!4m2!3m1!1s0x48670ebdf00f94a7:0x6df1cea35ed2bfb0?sa=X&ved=2ahUKEwjUyJGI2v6BAxUXhv0HHSt2Dy8Q8gF6BAgQEAA&ved=2ahUKEwjUyJGI2v6BAxUXhv0HHSt2Dy8Q8gF6BAgTEAI"
                   target="_blank"
                   rel="noreferrer"
                   className="mini__block__link">
                  Ground Floor, 71 Lower Baggot Street,
                  Dublin, D02 P593, Ireland

                </a>
              </div>
              <div className="mini__block">
                <h3>Mail us</h3>
                <a href="mailto:info@esh-alpha.com"
                   className="mini__block__link"
                >
                  info@esh-alpha.com
                </a>
              </div>
              <div className="mini__block">
                <h3>Web</h3>
                <Link className="mini__block__link" to="/">
                  www.esh-alpha.com
                </Link>
              </div>

            </div>
          </div>
        </div>

        <div className="contact__block__bottom">
          <div className="contact__block__form">
            <h2 className="contact__block__title">
              <span className="contact__block__title--stong">Love to hear from you <br /></span>leave a message
            </h2>

            <form className="form" ref={formRef} onReset={clearForm} onSubmit={sendEmail}>
              <label className="form__lable" htmlFor="name">
                Your Name
                <input
                  className={classNames('form__field', { 'is-danger': errors.name })}
                  type="text"
                  name="name"
                  id="name"
                  value={name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <p className="help">Name is required</p>
                )}
              </label>

              <label className="form__lable" htmlFor="email">
                Your email
                <input
                  className={classNames('form__field', { 'is-danger': errors.email })}
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <p className="help">Email is required</p>
                )}
              </label>

              <label className="form__lable" htmlFor="phone">
                Phone
                <input
                  className={classNames('form__field', { 'is-danger': errors.phone })}
                  type="text"
                  name="phone"
                  id="phone"
                  value={phone}
                  onChange={handleChange}
                />
                {errors.phone && (
                  <p className="help">Phone is required</p>
                )}
              </label>

              <label className="form__lable" htmlFor="subject">
                Subject
                <input
                  className={classNames('form__field', { 'is-danger': errors.subject })}
                  type="text"
                  name="subject"
                  id="subject"
                  value={subject}
                  onChange={handleChange}
                />
                {errors.subject && (
                  <p className="help">Subject is required</p>
                )}
              </label>


              <label className="form__lable grid-1-3" htmlFor="message">
                Message
                <textarea
                  className={classNames('form__field__area', { 'is-danger': errors.message })}
                  name="message"
                  id="message"
                  rows={4}
                  cols={40}
                  value={message}
                  onChange={handleChange}
                />
                {errors.message && (
                  <p className="help help--position-area">Message is required</p>
                )}

              </label>

            </form>

                <button
                  type="submit"
                  onClick={sendEmail}
                  className={classNames('button', 'btn', 'btn--dark_purple', 'btn--position', 'btn-space', {
                    'btn--loading' : submitting
                  })}
                >
                  <span className={classNames({ 'btn-text--hidden': submitting })}>
                    Send now
                  </span>
                </button>

            <MapLeaflet />

          </div>
        </div>
      </div>
    </div>
  </>
};
